<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
@if (msel) {
<div class="scrolling-region">
  <div class="table-container">
    <table mat-table #contributorTable [dataSource]="mselUnitDataSource" multiTemplateDataRows>
      <!-- action column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="column-action">&nbsp;</th>
        <td mat-cell *matCellDef="let element" class="column-action">
          @if (canManageMsel()) {
          <button mat-icon-button (click)="removeUnitFromMsel(element.id); $event.stopPropagation();"
            title="Remove unit from MSEL">
            <mat-icon class="mdi-24px self-center" fontIcon="mdi-minus-circle-outline"></mat-icon>
          </button>
          }
        </td>
      </ng-container>
      <!-- shortName Column -->
      <ng-container matColumnDef="shortName">
        <th mat-header-cell *matHeaderCellDef class="column-short-name">Short Name</th>
        <td mat-cell *matCellDef="let element" class="column-short-name">
          {{ getUnit(element.unitId).shortName }}
        </td>
      </ng-container>
      <!-- name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="column-name">Name</th>
        <td mat-cell *matCellDef="let element" class="column-name">
          {{ getUnit(element.unitId).name }}
        </td>
      </ng-container>
      <!-- Expanded Content Column -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
          <div [@detailExpand]="element.id == expandedElementId ? 'expanded' : 'collapsed'" style="overflow: hidden">
            @if (expandedElementId === element.id) {
            <div class="expanded-detail-div">
              @for (user of getMselUnitUsers(element.unitId); track user) {
              <div class="unit-detail">
                <div class="user-name four-cell">{{ user.name }}</div>
                @for (mselRole of getMselRolesToDisplay(); track mselRole) {
                <div class="msel-role one-cell">
                  <mat-checkbox [checked]="hasMselRole(user.id, mselRole)"
                    (change)="toggleMselRole(user.id, mselRole, $event.checked)" (click)="$event.stopPropagation();"
                    style="margin-right: 20px;" [disabled]="!canManageMsel() || isOwnOwnerRole(user.id, mselRole)"
                    [matTooltip]="getRoleDescription(mselRole)">{{ mselRole }}</mat-checkbox>
                </div>
                }
              </div>
              }
              @if (getMselUnitUsers(element.unitId).length === 0) {
              <div class="unit-detail">This unit has no users.</div>
              }
            </div>
            }
          </div>
        </td>
      </ng-container>
      <!-- row definitions -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class]="getRowClass(row.id)"
        (click)="rowClicked(row)"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
    </table>
  </div>
  @if (canManageMsel()) {
  <div class="add-unit-container">
    <mat-expansion-panel>
      <mat-expansion-panel-header (click)="$event.stopPropagation();">
        Add a Contributor Unit
      </mat-expansion-panel-header>
      @for (unit of getUnitList(); track unit) {
      <div class="other-units-div">
        <button mat-icon-button (click)="addUnitToMsel(unit.id); $event.stopPropagation();" title="Add unit to MSEL">
          <mat-icon class="mdi-24px self-center" fontIcon="mdi-plus-circle-outline"></mat-icon>
        </button>
        <span class="center-self">{{ unit.shortName }} - {{ unit.name }}</span>
      </div>
      }
    </mat-expansion-panel>
  </div>
  }
</div>
}
